import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import { IEmail } from "shared/interfaces/cadastrosN2";

interface ModalCadastroEmailProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (email: IEmail) => void;
  emailData?: IEmail;
}

export const ModalCadastroEmail = ({
  isOpen,
  onClose,
  onSave,
  emailData,
}: ModalCadastroEmailProps) => {
  const [nomeDestinatario, setNomeDestinatario] = useState("");
  const [email, setEmail] = useState("");
  const [erros, setErros] = useState<{ nome?: string; email?: string }>({});

  useEffect(() => {
    if (emailData) {
      setNomeDestinatario(emailData.nomeDestinatario);
      setEmail(emailData.email);
    } else {
      setNomeDestinatario("");
      setEmail("");
    }
    setErros({});
  }, [emailData, isOpen]);

  const validarEmail = (email: string): boolean => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  const handleSalvar = () => {
    const novosErros: { nome?: string; email?: string } = {};

    if (!nomeDestinatario.trim()) {
      novosErros.nome = "Campo obrigatório";
    }

    if (!email.trim()) {
      novosErros.email = "Campo obrigatório";
    } else if (!validarEmail(email)) {
      novosErros.email = "E-mail inválido";
    }

    if (Object.keys(novosErros).length > 0) {
      setErros(novosErros);
      return;
    }

    onSave({
      id: emailData?.id,
      nomeDestinatario: nomeDestinatario.trim(),
      email: email.trim(),
    });
    handleClose();
  };

  const handleClose = () => {
    setNomeDestinatario("");
    setEmail("");
    setErros({});
    onClose();
  };

  return (
    <Dialog open={isOpen} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>{emailData ? "Editar E-mail" : "Adicionar E-mail para Notificação"}</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          label="Nome do destinatário"
          value={nomeDestinatario}
          onChange={(e) => {
            setNomeDestinatario(e.target.value);
            setErros((prev) => ({ ...prev, nome: undefined }));
          }}
          error={!!erros.nome}
          helperText={erros.nome}
          sx={{ mt: 2, mb: 2 }}
        />
        <TextField
          fullWidth
          label="E-mail"
          type="email"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
            setErros((prev) => ({ ...prev, email: undefined }));
          }}
          error={!!erros.email}
          helperText={erros.email}
        />
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={handleClose} color="inherit">
          CANCELAR
        </Button>
        <Button variant="contained" onClick={handleSalvar}>
          SALVAR
        </Button>
      </DialogActions>
    </Dialog>
  );
};

